import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { apiService } from '../services/api';

const useReferralStore = create(devtools((set, get) => ({
	// Данные рефералов
	referralCode: null,
	stats: {
		invitedCount: 0,
		activeUsers: 0,
		totalEarned: 0
	},
	referrals: [],
	pagination: {
		page: 1,
		limit: 10,
		total: 0,
		totalPages: 0
	},
	loading: false,
	error: null,
	lastUpdated: null, // Время последнего обновления

	// Получить все данные рефералов
	fetchReferrals: async (page = 1, force = false) => {
		const state = get();
		const now = Date.now();

		// Проверяем, прошла ли минута с последнего обновления
		if (!force && state.lastUpdated && (now - state.lastUpdated) < 60000) {
			console.log('Данные рефералов были обновлены менее минуты назад, пропускаем запрос');
			return;
		}

		set({ loading: true, error: null });
		try {
			const response = await apiService.getReferrals(page);
			const data = response.data;
			set({
				referralCode: data.referralCode,
				stats: data.stats,
				referrals: data.referrals || [],
				pagination: data.pagination,
				loading: false,
				lastUpdated: now
			});
		} catch (err) {
			set({
				error: err.message || 'Ошибка при загрузке данных рефералов',
				loading: false
			});
		}
	},

	setPage: (page) => set(state => ({
		pagination: { ...state.pagination, page }
	})),

	// Сбросить состояние
	reset: () => {
		set({
			referralCode: null,
			stats: {
				invitedCount: 0,
				activeUsers: 0,
				totalEarned: 0
			},
			referrals: [],
			pagination: {
				page: 1,
				limit: 10,
				total: 0,
				totalPages: 0
			},
			loading: false,
			error: null,
			lastUpdated: null
		});
	}
}), { name: 'ReferralStore' }));

export default useReferralStore;

